import React from 'react'
import { translation } from 'assets/translations/translations'
import './MainBanner.css'

type Props = {
  language: string
}

const MainBanner = ({ language }: Props) => (
  <section className='main-banner-main'>
    <div className='main-banner-overlay' />
    <div className='main-banner-content'>
      <span className='main-banner-kicker'>ILE Soft Electronics</span>
      <h1 className='main-banner-text'>
        {translation(language, 'headerText')}
      </h1>
    </div>
  </section>
)

export default MainBanner